import React from "react";
import ssc from "../../images/ssc.jpg";
import cbse from "../../images/cbse.jpg";
import "./Branches.css";

const Branches = () => {
  return (
    <div className="aboutUs">
        <h1 style={{ textAlign: "center", marginBottom: "20px", position: "relative" }}>
        <span style={{ borderBottom: "5px solid gold", padding: "3px", display: "inline-block" }}>
          Branches
        </span>
      </h1>
      <div className="aboutContents flex justify-center gap-40">
        <div className="w-90 relative">
          {/* Side with left image */}
          <div className="imageContainer">
            <img src={ssc} alt="SSC description" className="w-full h-full" />
            <div className="overlay">
              <h2>SSC</h2>
              <h4>
                State Board of Secondary [SSC]
                <br />
                Karimnagar
                <br />
              </h4>
            </div>
          </div>
        </div>
        <div className="w-90 relative">
          {/* Side with left image */}
          <div className="imageContainer">
            <img src={cbse} alt="CBSE description" className="w-full h-full" />
            <div className="overlay">
              <h2>CBSE</h2>
              <h4>
                Central Board of Secondary Education [CBSE]
                <br />
                Karimnagar
                <br />
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Branches;
